import { useMutation } from "@tanstack/react-query";
import { useNotification } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { Promocode } from "@modules/promocodes/types";
import { PromocodeFormValues } from "@modules/promocodes/validations";

import { createPromocodeService } from "./service";
import { UseCreatePromocodeMutationOptions } from "./types";

export function useCreatePromocodeMutation(
  options?: UseCreatePromocodeMutationOptions
) {
  const { open } = useNotification();

  return useMutation<Promocode, ApiError, PromocodeFormValues>({
    mutationFn: createPromocodeService,
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
